
import React, { memo } from "react";
import "./AboutCEO.css";
import CEOImage from "../../assets/aboutus/CEO.png";

const AboutCEO = memo(() => {
  return (
    <section className="aboutceo-section" aria-labelledby="aboutceo-heading">
      <div className="aboutceo-container">
        {/* Section Title */}
        <header className="aboutceo-header">
          <h2 id="aboutceo-heading" className="aboutceo-title">
            About Our CEO
          </h2>
        </header>

        {/* Main content: image + text */}
        <div className="aboutceo-content">
          {/* PNG image */}
          <div className="aboutceo-image-wrapper">
            <img
              src={CEOImage}
              alt="CEO portrait illustration"
              className="aboutceo-image"
              loading="lazy"
            />
          </div>

          {/* CEO descriptive text */}
          <div className="aboutceo-text">
            <h3 className="aboutceo-subtitle">
              Hello, I am Deep the Founder Of Web Bunny Development.
            </h3>

            <div className="aboutceo-paragraphs">
              <p>
                I've been fascinated by computers since I was young and used to
                wonder, "How do apps work, and can I develop one myself?"
              </p>

              <p>
                All that hard work paid off<span style={{fontFamily:'cursive'}}>:</span> I turned into a high-rated freelancer
                on Upwork by creating clean, simple-to-use iOS apps for various
                types of businesses.
              </p>

              <p>
                I built the company from the ground up, writing the first version of 
                our product, managing projects, creating marketing campaigns, and 
                talking with each client directly. Handling all these responsibilities
                shaped my leadership style<span style={{fontFamily:'cursive'}}>:</span> very practical, adaptable, and focused on
                getting results.
              </p>

              <p>
                Today, our growing team brings diverse skills to the table, with
                native iOS development as our standout expertise.
              </p>

              <p>
                9+ years on, we're the technology partner businesses turn to bring
                big ideas to life as high-performing digital solutions. I still
                get to enjoy mentoring my team, coding, and driving new ideas to
                reality - <span className="special-fonts">because the best is yet to come.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});

AboutCEO.displayName = "AboutCEO";

export default AboutCEO;
